export default __webpack_public_path__ + "static/media/notification-white.ccea4f0a.svg";